import { createContext, useContext, useReducer, useEffect } from "react";
import { reducer } from "./reducer";
import ACTIONS from "../utils/constant/stringConstant";

const AppContext = createContext();

const initialState = {
  user: {
    id: "",
    username: "",
    name: "",
    email: "",
    isLogin: false,
    accessToken: "",
  },
};

const AppProvider = ({ children }) => {
  const [store, dispatch] = useReducer(reducer, initialState, () => {
    const storedState = localStorage.getItem(ACTIONS.LOCAL_STORAGE_KEY);
    return storedState ? JSON.parse(storedState) : initialState;
  });

  useEffect(() => {
    localStorage.setItem(ACTIONS.LOCAL_STORAGE_KEY, JSON.stringify(store));
  }, [store]);

  return (
    <AppContext.Provider value={{ store, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

const useAppContext = () => {
  return useContext(AppContext);
};

export { AppProvider, useAppContext, AppContext };
